/**
 * Shop / Inventory card preview for Banner cosmetics (no cursor, rectangular fit).
 */
import {
  getCachedCosmeticImage,
  loadCosmeticImage,
} from "./cursor-cosmetics";
import { ANIM_FRAME_MS } from "./shop-creator-fx";

export const BANNER_CARD_W = 280;
export const BANNER_CARD_H = 70;

/** Draw banner art fitted into the canvas (contain). Never draws the play cursor. */
export function paintBannerCardArt(
  canvas: HTMLCanvasElement,
  imageData: string,
  animationFrames: string[] | null | undefined,
  mode: "idle" | "preview",
) {
  const ctx = canvas.getContext("2d");
  if (!ctx) return;
  ctx.clearRect(0, 0, canvas.width, canvas.height);

  const drawSrc = (src: CanvasImageSource | null | undefined) => {
    if (!src) return;
    const iw =
      (src as HTMLImageElement).naturalWidth ||
      (src as HTMLCanvasElement).width ||
      BANNER_CARD_W;
    const ih =
      (src as HTMLImageElement).naturalHeight ||
      (src as HTMLCanvasElement).height ||
      BANNER_CARD_H;
    if (iw <= 0 || ih <= 0) return;
    const scale = Math.min(canvas.width / iw, canvas.height / ih);
    const dw = iw * scale;
    const dh = ih * scale;
    ctx.imageSmoothingEnabled = false;
    ctx.drawImage(src, (canvas.width - dw) / 2, (canvas.height - dh) / 2, dw, dh);
  };

  drawSrc(getCachedCosmeticImage(imageData));
  if (animationFrames?.length) {
    if (mode === "preview") {
      const fi = Math.floor(performance.now() / ANIM_FRAME_MS) % animationFrames.length;
      drawSrc(getCachedCosmeticImage(animationFrames[fi]));
    } else {
      drawSrc(getCachedCosmeticImage(animationFrames[0]));
    }
  }
}

export async function ensureBannerCardImages(
  imageData: string,
  animationFrames: string[] | null | undefined,
) {
  await loadCosmeticImage(imageData);
  if (animationFrames?.length) {
    await Promise.all(animationFrames.map((f) => loadCosmeticImage(f)));
  }
}
